module.exports = __webpack_public_path__ + "img/KARACH.12b5c6c3.png";